const menus = [{
  name: '首页',
  key: 'index',
  url: '/'
}, {
  name: '走进白溪',
  key: 'info',
  url: '/info/about',
  children: [{
    name: '公司介绍',
    key: 'about',
    url: '/info/about'
  // }, {
  //   name: '董事长致辞',
  //   key: 'speech',
  //   url: '/info/speech'
  }, {
    name: '企业文化',
    key: 'culture',
    url: '/info/culture'
  }, {
    name: '核心团队',
    key: 'team',
    url: '/info/team'
  // }, {
  //   name: '白溪荣誉',
  //   key: 'honor',
  //   url: '/info/honor'
  }]
}, {
//   name: '白溪动态',
//   key: 'dynamic',
//   url: '/dynamic/notice',
//   children: [{
//     name: '白溪公告',
//     key: 'notice',
//     url: '/dynamic/notice'
//   }, {
//     name: '白溪投教',
//     key: 'teach',
//     url: '/dynamic/teach'
//   }]
// }, {
  name: '投研资讯',
  key: 'research',
  url: '/research/angle',
  children: [{
    name: '白溪视角',
    key: 'angle',
    url: '/research/angle'
  }, {
    name: '每周观评',
    key: 'report',
    url: '/research/report'
  }, {
    name: '投资者教育',
    key: 'teach',
    url: '/research/teach'
  }]
}, {
//   name: '白溪产品',
//   key: 'product',
//   url: '/product'
// }, {
  name: '客户服务',
  key: 'client',
  // url: '/client/inquire',
  url: '/',
  children: [{
    name: '净值查询',
    key: 'inquire',
    // url: '/client/inquire'
    url: '/'
  }, {
    name: '个人中心',
    key: 'center',
    // url: '/client/center'
    url: '/'
  }, {
    name: '产品公告',
    key: 'product',
    // url: '/client/product'
    url: '/'
  }]
}, {
  name: '联系我们',
  key: 'contact',
  url: '/contact'
}];

export default menus;

// export const subMenu = [{
//   name: '走进白溪',
//   key: 'info',
//   children: [{
//     name: '关于白溪',
//     key: 'about',
//     url: '/info/about'
//   }, {
//     name: '董事长致辞',
//     key: 'speech',
//     url: '/info/speech'
//   }, {
//     name: '企业文化',
//     key: 'culture',
//     url: '/info/culture'
//   }, {
//     name: '核心团队',
//     key: 'team',
//     url: '/info/team'
//   }, {
//     name: '白溪荣誉',
//     key: 'honor',
//     url: '/info/honor'
//   }]
// }, {
//   name: '白溪动态',
//   key: 'dynamic',
//   children: [{
//     name: '白溪公告',
//     key: 'notice',
//     url: '/dynamic/notice'
//   }, {
//     name: '白溪投教',
//     key: 'teach',
//     url: '/dynamic/teach'
//   }]
// }, {
//   name: '投研咨讯',
//   key: 'research',
//   children: [{
//     name: '白溪视角',
//     key: 'angle',
//     url: '/research/angle'
//   }, {
//     name: '投研精报',
//     key: 'report',
//     url: '/research/report'
//   }]
// }];
